/**
 * Via da un risultato del completamento indirizzi Google.
 *
 * Quando Google non restituisce la componente "route", i form salvavano in
 * `street_address` l'intero `formatted_address` ("Via Colonnetta, 40, 66100
 * Chieti CH, Italia"): nel contratto CAP e città uscivano poi due volte.
 * Qui si tiene solo il primo pezzo prima della virgola, cioè la via.
 */
export interface PlaceStreetParts {
  street_address?: string | null;
  street_number?: string | null;
  formatted_address?: string | null;
}

export function streetFromPlace(place: PlaceStreetParts | null | undefined): string {
  const route = (place?.street_address ?? '').trim();
  if (route) return route;
  const first = (place?.formatted_address ?? '').split(',')[0]?.trim() ?? '';
  // Una sola parte che inizia con il CAP non è una via
  return /^\d{5}\b/.test(first) ? '' : first;
}

/** "Via civico" per i form che tengono via e civico in un solo campo. */
export function streetLineFromPlace(place: PlaceStreetParts | null | undefined): string {
  const street = streetFromPlace(place);
  const number = (place?.street_number ?? '').trim();
  if (!street) return '';
  return number ? `${street} ${number}` : street;
}
